import { trpc } from '@/utils/trpc'

export const useGetTeamInvitees = ({ teamId }: { teamId: string }) => {
  const { data: teamInvitees, isLoading: isLoadingTeamInvitees } = trpc.teamInvitees.useQuery({
    teamId: teamId,
  })
  return { teamInvitees, isLoadingTeamInvitees }
}
